import * as React from "react";
import { type PropsWithChildren } from "react";

export enum Routes {
    CompatibilityCheck = "compatibilityCheck",
    ComponentGroupOverview = "componentGroupOverview",
    Landing = "landing",
    SearchResult = "searchResult",
    SubGroupDetail = "subGroupDetail",
    VisualSelector = "visualSelector",
    Wishlist = "wishlist",
}

export interface RouterContextValue {
    currentRoute: Routes;
    setRoute: (route: Routes) => void;
}

const RouterContext = React.createContext<RouterContextValue>(undefined!);

const RouterProvider: React.FunctionComponent<{ initialRoute: Routes } & PropsWithChildren> = ({ initialRoute, children }) => {
    const [route, setRoute] = React.useState<Routes>(initialRoute);

    return <RouterContext.Provider value={{ currentRoute: route, setRoute }}>{children}</RouterContext.Provider>;
};

export { RouterContext, RouterProvider };
